import { render, staticRenderFns } from "./Ulotki.vue?vue&type=template&id=3d64f570&scoped=true&"
import script from "./Ulotki.vue?vue&type=script&lang=js&"
export * from "./Ulotki.vue?vue&type=script&lang=js&"
import style0 from "./Ulotki.vue?vue&type=style&index=0&id=3d64f570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64f570",
  null
  
)

export default component.exports